import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";

function AgeCheck() {
  const setMaxAge = 180 * 24 * 60 * 60; // 180 Tage in Sekunden
  const [ageCheckVisibility, setAgeCheckVisiblity] = useState("none");
  const [ageCheckDeclinedVisibility, setAgeCheckDeclinedVisiblity] = useState("none");
  const [ageCheckActiveVisibility, setAgeCheckActiveVisiblity] = useState("flex");
  const [ageCheck, setAgecheck] = useState(true);

  const [cookies, setCookie, removeCookie] = useCookies("agecheck");

  useEffect(() => {
    if (
      cookies.agecheck ||
      window.location.toString().includes("localhost:3010") || window.location.toString().includes("https://hpew.datenwerk.dev/")
    ) {
      hideAgeCheck();
    } else {
      showAgeCheck();
    }
  }, [cookies]);

  const underSixteen =() =>{
    setAgeCheckActiveVisiblity("none");
    setAgeCheckDeclinedVisiblity("flex");
  }

  const overSixteen = () => {
    setCookie("agecheck", ageCheck, { path: "/", maxAge: setMaxAge });
    hideAgeCheck();
  };

  const hideAgeCheck = () => {
    setAgeCheckVisiblity("none");
  };

  const showAgeCheck = () => {
    setAgeCheckVisiblity("flex");
  };

  return (
    <div style={{ display: `${ageCheckVisibility}` }} className="agecheck">
      <div style={{ display: `${ageCheckActiveVisibility}` }}  className="agecheck--container ">
        <div  className="agecheck--intro">
          <span>Wilkommen bei</span>
          <h2 className="text-2xl">"Erfolgreichgastro!"</h2>
        </div>
        <div className="flex flex-col items-center" id="change-content">
          <div className="agecheck--textcontent" id="agecheck--textcontent">
            <p>
              Als eines der führenden Brauereiunternehmen in Deutschland setzt
              sich die Paulaner Brauerei Gruppe für einen
              verantwortungsbewussten Umgang mit alkoholischen Getränken ein.
              Demzufolge richten wir keine Werbung an Jugendliche.
            </p>
            <p>
              Wir bitten Sie daher zu bestätigen, dass Sie mindestens 16 Jahre
              alt sind!
            </p>
          </div>
          <div className="agecheck--buttons">
            <button className="agecheck--button" onClick={overSixteen}>
              Ja, ich bin 16 Jahre oder älter
            </button>
            <button className="agecheck--button" onClick={underSixteen}>
              Nein, ich bin noch keine 16 Jahre alt
            </button>
          </div>
        </div>

        <div className="agecheck--links">
          <a href="">Impressum</a>
          <a href="">Datenschutz</a>
          <a href="">Nutzungsbedingungen</a>
        </div>
      </div>

      <div style={{ display: `${ageCheckDeclinedVisibility}` }}  className="agegcheck-under-sixteen">
        <div className="agecheck--intro">
          <span>Wilkommen bei</span>
          <h2 className="text-2xl">"Erfolgreichgastro!"</h2>
        </div>
        <div className="flex flex-col items-center" id="change-content">
          <div className="agecheck--textcontent" id="agecheck--textcontent">
            <p>
              Warte bitte noch ein paar Jahre! Die Erfolgreichgastro Website
              steht nur Personen zur Verfügung, die mindestens 16 Jahre alt
              sind. Warum wir keine Werbung für Jugendliche machen, erfährst Du
              auf den Seiten des Deutschen Brauerbundes:
            </p>
          </div>
          <div className="agecheck--buttons">
            <button className="agecheck--button">
              <a href="https://www.bierbewusstgeniessen.de/">www.bier-bewusst-geniessen.de</a>
            </button>
          </div>
        </div>
      </div>

    </div>
  );
}

export default AgeCheck;
